var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHangerSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4498 15.8998L13.4998 12.0748C13.0498 11.7748 12.7498 11.2498 12.7498 10.7248C12.7498 10.1248 13.0498 9.67479 13.4248 9.37479C14.5498 8.77479 15.1498 7.49979 14.9248 6.22479C14.6998 5.02479 13.7248 4.04979 12.5248 3.82479C11.6248 3.67479 10.7248 3.89979 10.0498 4.49979C9.37477 5.02479 8.99977 5.84979 8.99977 6.74979V7.49979C8.99977 7.94979 9.29978 8.24979 9.74977 8.24979C10.1998 8.24979 10.4998 7.94979 10.4998 7.49979V6.74979C10.4998 6.29979 10.7248 5.84979 11.0248 5.62479C11.3998 5.32479 11.7748 5.24979 12.2998 5.32479C12.8998 5.39979 13.4248 5.92479 13.4998 6.52479C13.6498 7.19979 13.3498 7.79979 12.7498 8.09979C11.8498 8.62479 11.2498 9.59979 11.2498 10.7248C11.2498 11.0248 11.2498 11.2498 11.3248 11.5498L2.47478 15.8998C1.87478 16.1998 1.49978 16.8748 1.64978 17.5498C1.79978 18.2248 2.39978 18.6748 3.07477 18.6748H20.6248C21.3748 18.6748 21.8998 18.2248 22.0498 17.5498C22.3498 16.8748 22.0498 16.1998 21.4498 15.8998ZM3.14978 17.2498L12.0748 12.8248C12.2998 13.0498 12.5248 13.1998 12.7498 13.4248L20.7748 17.2498H3.14978Z",
    fill: "#9393B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangerSvgrepocom);
export default __webpack_public_path__ + "static/media/hanger_svgrepo.com.8429211ddc14c06b7172a5158bf0b36c.svg";
export { ForwardRef as ReactComponent };